export default () => {
  const accordion = document.querySelectorAll('.accordion')

  if (accordion) {
    for (let i = 0; i < accordion.length; i += 1) {
      accordion[i].addEventListener('click', () => {
        accordion[i].classList.toggle('expanded')
        const panel = accordion[i].nextElementSibling
        if (!panel) {
          return
        } 
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null
          panel.style.height = null
        } else {
          panel.style.height = `${panel.scrollHeight + 16}px`
          panel.style.maxHeight = `${panel.scrollHeight + 16}px`
        }
      })
    }
  }
}
